import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Exogov · Empowering Your Digital Experience</p>
        <h1>Transform Your Online Presence.</h1>
        <p className="lede">
          At Exogov, we provide innovative solutions to elevate your digital experience. Our platform is designed to help you create, manage, and optimize your online assets effortlessly.
        </p>
        <div className="cta-row">
          <a href="https://exogov.com/docs" target="_blank">
            Learn More
          </a>
          <a href="https://exogov.com/about" target="_blank" className="secondary">
            Discover Exogov
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Launch with Ease</h2>
          <p>
            Get your website up and running in no time. Our streamlined process ensures a hassle-free launch, allowing you to focus on what matters most.
          </p>
        </article>
        <article>
          <h2>Personalize Your Experience</h2>
          <p>
            Customize every aspect of your site to reflect your brand. With our flexible tools, you can create a unique online identity that resonates with your audience.
          </p>
        </article>
        <article>
          <h2>Stay Ahead with Automation</h2>
          <p>
            Leverage our automation features to keep your content fresh and engaging. Schedule updates and manage your site effortlessly, ensuring you’re always in tune with your audience.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;